import React from 'react';
import Card from '../Card/Card';
import Notification from '../Notification';

export default function NoDocumentFound() {
  return (
    <Card container className="text-center horizontal-padding">
      <Notification type="info" data-name="not-found">
        No document found
      </Notification>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Document/NoDocumentFound.js